import { render } from "./CustomerDepotDiscountGroupsManagement.html?vue&type=template&id=6635a181&scoped=true"
import script from "./CustomerDepotDiscountGroupsManagement.js?vue&type=script&lang=js"
export * from "./CustomerDepotDiscountGroupsManagement.js?vue&type=script&lang=js"

import "./CustomerDepotDiscountGroupsManagement.css?vue&type=style&index=0&id=6635a181&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6635a181"]])

export default __exports__